module.exports = __webpack_public_path__ + "img/key_icon.c38b7378.svg";